export class Emitter<T> {
  private listeners = new Set<(value: T) => void>()

  addListener(listener: (value: T) => void) {
    this.listeners.add(listener)
  }

  removeListener(listener: (value: T) => void) {
    this.listeners.delete(listener)
  }

  emit(value: T) {
    for (const listener of this.listeners) {
      listener(value)
    }
  }
}
